import {
    Box,
    Flex,
    Input,
    Table,
    TableCaption,
    TableContainer,
    Tbody,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useState } from 'react'
import Initial from '../../components/Initial'
import MenuUser from '../../components/MenuUser'
import Navbar from '../../components/Navbar'
import NTabs from '../../components/NTabs'
import { useGet } from '../../hooks/useHttp'
import Booking from '../../models/booking'
import BookingSelect from './components/BookingSelect'
import Row from './components/Row'
import getName from './utils/getName'

export default function PayCommissions() {
    const [date, setDate] = useState(() => dayjs().format('YYYY-MM-DD'))
    const [bookingIds, setBookingIds] = useState<string>('')
    const [search, setSearch] = useState('')
    const { data, reload } = useGet<Booking[]>(
        `/api/bookings?sort=id&types=1,2&date=${date}&booking_ids=${bookingIds}`,
        []
    )

    return (
        <Initial position="relative">
            <Navbar component={<NTabs />}>
                <Box px="5" py="1">
                    <MenuUser />
                </Box>
            </Navbar>
            <Box py={6} px={{ base: 4, md: 10 }}>
                <Flex
                    gap={2}
                    justifyContent="flex-start"
                    flexWrap="wrap"
                    mb={4}
                >
                    <Input
                        size="md"
                        borderRadius="full"
                        w={['full', 'full', 'auto']}
                        type="date"
                        bg="base-4"
                        onChange={ev => setDate(ev.target.value)}
                        value={date}
                    />
                    <BookingSelect
                        date={date}
                        bookingId={bookingIds}
                        onBooking={setBookingIds}
                    />
                    <Input
                        type="search"
                        bg="base-4"
                        rounded="full"
                        w={['full', 'full', 'auto']}
                        placeholder="Búsqueda"
                        value={search}
                        onChange={ev => setSearch(ev.target.value)}
                    />
                </Flex>
                <TableContainer>
                    <Table size="md" className="table-a-la-orden">
                        <Thead>
                            <Tr>
                                <Th textAlign="center">Hora de reserva</Th>
                                <Th textAlign="center">Guía turistico</Th>
                                <Th textAlign="center">Platos vendidos</Th>
                                <Th textAlign="center">Estado</Th>
                                <Th textAlign="center">Comisión</Th>
                                <Th textAlign="center">Pago por comisión</Th>
                                <Th textAlign="center">Acciones</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.result
                                .filter(
                                    b =>
                                        getName(b)
                                            .toLowerCase()
                                            .search(search.toLowerCase()) > -1
                                )
                                .map(booking => (
                                    <Row
                                        key={booking.id}
                                        booking={booking}
                                        onReload={reload}
                                    />
                                ))}
                        </Tbody>
                        {data.result.length === 0 && (
                            <TableCaption>Sin reservas actuales</TableCaption>
                        )}
                    </Table>
                </TableContainer>
            </Box>
        </Initial>
    )
}
